import { Link } from '@tanstack/react-router';

/** Content of the 404 page: the prerendered /404 page and the router's not-found fallback. */
export default function NotFound() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">404</h1>
        <h2 className="page-subtitle">Hoppá, az oldal nem található.</h2>
        Térj vissza a <Link to="/">kezdőoldalra</Link> vagy nézd meg a{' '}
        <Link to="/$handle" params={{ handle: 'karkotok' }}>
          karkötőket.
        </Link>
      </div>
    </div>
  );
}
